
// 请求的url
const countMapUrl = [
    { troopsType: '0', value: '消防支队', url: '' },
    { troopsType: '1', value: '救援站(中队)', url: '' },
    { troopsType: '2', value: '消防大队', url: '' },
    {
        troopsType: '3',
        value: '微型消防站 ',
        //微站设备数量
        sySbslUrl: '/webapi/smokeEquipment/StatusStatistics',
        //微站地图数量
        syMapUrl: '/webapi/smokeEquipment/StatusStatistics1',
        // 微站备防人员
        syBfry: '/webapi/main/theSameDay',
        // 微站今日处警
        syJrcjUrl: '/wxf/alarmSingle/queryTodaySingleCount',
        // 微站近30日电动车进楼
        syDdcjlUrl: '/wxf/alarmSingle/list4',
        // 微站近30日楼道堆物
        syLddwUrl: '/wxf/alarmSingle/list3',
        // 近30日车辆堵占消防车道
        syXftdUrl: '/wxf/alarmSingle/community',
        // 高发时间段
        syGfsjdUrl: '/webapi/main/tallTime',
        // 电气隐患
        syDqyhUrl: '/wxf/alarmSingle/report/type ',
    },
    {
        troopsType: '4',
        value: '街道街区',
        //街道设备数量
        sySbslUrl: '/webapi/smokeEquipment/devicesNum',
        //街道地图数量
        syMapUrl: '/webapi/smokeEquipment/StatusStatistics/street',
        // 街道备防人员
        syBfry: '/webapi/smokeEquipment/theSameDay',
        // 微站今日处警
        syJrcjUrl: '/webapi/smokeEquipment/queryTodaySingleCount',
        //街道近30日电动车进楼
        syDdcjlUrl: '/webapi/smokeEquipment/diandongche',
        // 街道近30日楼道堆物
        syLddwUrl: '/webapi/smokeEquipment/duiwu',
        // 近30日车辆堵占消防车道
        syXftdUrl: '/webapi/smokeEquipment/community',
        // 高发时间段
        syGfsjdUrl: '/webapi/smokeEquipment/tallTime',
        // 电气隐患
        syDqyhUrl: '/wxf/alarmSingle/report/type ',
    },
    { troopsType: '5', value: '小区物业前台', url: '' }
]

export default countMapUrl




// WEBPACK FOOTER //
// ./src/pages/index/components/userCodeUrl.js